import { createAction, props } from "@ngrx/store";

import { ProductFeature } from "./product-feature.models";

export const getProductFeatures = createAction(
  "[Product Feature] Get Product Features"
);

export const getProductFeaturesSuccess = createAction(
  "[Product Feature] Get Product Features Success",
  props<{ productFeatures: ProductFeature[] }>()
);

export const getProductFeaturesFailure = createAction(
  "[Product Feature] Get Product Features Failure",
  props<{ error: string }>()
);

export const enableProductFeature = createAction(
  "[Product Feature] Enable Product Feature",
  props<{ id: string }>()
);

export const enableProductFeatureSuccess = createAction(
  "[Product Feature] Enable Product Feature Success",
  props<{ id: string }>()
);

export const enableProductFeatureFailure = createAction(
  "[Product Feature] Enable Product Feature Failure",
  props<{ id: string; error: string }>()
);

export const disableProductFeature = createAction(
  "[Product Feature] Disable Product Feature",
  props<{ id: string }>()
);

export const disableProductFeatureSuccess = createAction(
  "[Product Feature] Disable Product Feature Success",
  props<{ id: string }>()
);

export const disableProductFeatureFailure = createAction(
  "[Product Feature] Disable Product Feature Failure",
  props<{ id: string; error: string }>()
);
